import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PartnerService} from '../../../shared/services/partner.service';

@Component({
    selector: 'app-partner-detail-shell',
    templateUrl: './partner-detail-shell.component.html',
    styleUrls: ['./partner-detail-shell.component.scss']
})
export class PartnerDetailShellComponent implements OnInit {
    public toggleMenu = false;
    public partnerSlug: any;
    partner: any;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private partnerService: PartnerService) {
    }

    ngOnInit(): void {
        this.partnerSlug = this.activatedRoute.snapshot.params['slug'];
        this.getPartnerDetail();
    }

    goBack(): void {
        this.router.navigateByUrl('partner');
    }

    getPartnerDetail() {
        this.partnerService.detail(this.partnerSlug).subscribe(data => {
            if (data) {
                this.partner = data;
            }
        });
    }
}
